import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

@Directive({
    selector: '[documentBlurTrigger]',
})
export class DocumentBlurTriggerDirective {
    @Input() triggerFlag: boolean;
    @Output() documentBlurred: EventEmitter<any> = new EventEmitter<any>();
    @Input() paramArray: any[];

    private _boundOnClick: any;

    constructor(private readonly _el: ElementRef) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnChanges(args) {
        // eslint-disable-next-line no-prototype-builtins
        if (
            // eslint-disable-next-line no-prototype-builtins
            args.hasOwnProperty('triggerFlag') &&
            args.triggerFlag.currentValue === true
        ) {
            this.enableListener();
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnInit() {
        this._boundOnClick = this.close.bind(this);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    enableListener() {
        setTimeout(() => {
            document.removeEventListener('click', this._boundOnClick);
            document.addEventListener('click', this._boundOnClick, {
                passive: true,
            });
        }, 300);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    disableListener() {
        document.removeEventListener('click', this._boundOnClick);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    close(e) {
        const target = e.target;
        e.preventDefault();

        setTimeout(() => {
            if (this._el.nativeElement) {
                // if element is gone (will not work if element is *ngIf and if direct child of 'body')
                if (
                    target.tagName.toLowerCase() !== 'body' &&
                    $(target).closest('body').length === 0
                ) {
                    return;
                }

                // if element is inside this directive element
                if (
                    $(target).closest('[documentblurtrigger').length === 0 ||
                    !this._el.nativeElement.contains(target)
                ) {
                    this.documentBlurred.emit(false);
                    document.removeEventListener('click', this._boundOnClick);
                }
            }
        });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    onDestroy() {
        document.removeEventListener('click', this._boundOnClick);
    }
}
